<div #simpleMap class="simple-map"></div>